import Page from '../pages/model'
import api from '@/helpers/api'
import { each } from 'lodash'

export default {
    state: {

    },

    mutations: {

    },

    getters: {

    },

    actions: {
        fetchItems (store, params) {
            Page.dispatch('addLoader', 'roles.fetchItems')

            return api.get('/api/v1/dictionaries/Role', {params})
            .then(res => {
                store.dispatch('insertOrUpdate', { data: res.data.data })
                return res.data
            }).finally(()=>{
                Page.dispatch('removeLoader', 'roles.fetchItems')
            })
        },
        removeRolesByUser(store, id) {
            each(store.getters.query().where('userId', id).get(), item => {
                store.dispatch('delete', item.id)
            })
        }
    }
}
